import {
  Box,
  Button,
  Grid,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";

import { useCallback, useEffect, useState } from "react";
import theme from "./theme";
import { keyframes } from "@mui/system";
import { styled } from "@mui/material/styles";
import { postStatus, nextLot } from "../../Model/DeclaratorModel";

const blink = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const BlinkedBox = styled("div")({
  animation: `${blink} 1s linear infinite`,
});

const ButtonsFunction = ({ socketDeclarator, LiveDataddd, Datastatus }) => {
  const classes = theme();
  const [lotStatus, setLotStatus] = useState(Datastatus);
  const [openPass, setOpenPass] = useState(false);
  const [withdrawn, setWithdrawn] = useState(0);
  const handleClick = useCallback(async (message) => {

    setOpenPass(false);
  
    const DataBidStatus = {
      auction_id: LiveDataddd.auction_details.auction_id,
      setId: LiveDataddd.auction_details.id,
      lot_number: LiveDataddd.lot.details[0].lot_number,
      status: message,
    };
  
    if (!message) return;
  
    try {

      if (message === "PASS") {
        setLotStatus("PASS");
        const results = await postStatus(DataBidStatus);
        socketDeclarator.emit("send_status", {
          status: true,
          message: "PASS",
          nextCount: LiveDataddd.lot.details[0].lot_number,
        });
        return;
      }
      
      if (message === "NEXTSLOT") {
        try {
          const results = await nextLot(DataBidStatus);
          if (results.success) {
            socketDeclarator.emit("send_status", {
              status: true,
              message: message,
              nextCount: LiveDataddd.lot.details[0].lot_number,
            });
            setLotStatus("PENDING");
          }
        } catch (error) {
          console.error("NEXTSLOT error", error);
        }
        return;
      }
      if (message === "OPEN") {
        setLotStatus("OPEN");
        const results = await postStatus(DataBidStatus);
        socketDeclarator.emit("send_status", {
          status: true,
          message: message,
          nextCount: LiveDataddd.lot.details[0].lot_number,
        });
  
        return; // Stop further execution
      }
      try {
        const results = await postStatus(DataBidStatus);
  
        if (results.success) {
          setLotStatus(results.status);
          socketDeclarator.emit("send_status", {
            status: true,
            message: results.status,
            nextCount: LiveDataddd.lot.details[0].lot_number,
          });
        } else {
          socketDeclarator.emit("send_status", {
            status: true,
            message,
            nextCount: LiveDataddd.lot.details[0].lot_number,
          });
        }
      } catch (error) {
        console.error("postStatus error", error);
      }
    } catch (error) {
      console.error("handleClick error", error);
    }
  }, [LiveDataddd, socketDeclarator]);
  const handleRefreshAll = () => {
    socketDeclarator.emit("refreshAll");
  };
  

  
  const handleClickPass = () => setOpenPass(true);
  const handleClosePass = () => setOpenPass(false);

  useEffect(() => {
    try {

   

      const lot = LiveDataddd?.lot?.details?.[0];
      setWithdrawn(lot.isWithdrawn)
      setLotStatus(lot?.lot_status || "");

    } catch (error) {
      console.error("Initialization error", error);
    }


    if (!socketDeclarator) return;

    const handleStatusUpdate = (data) => {
      const incomingStatus = data.message;
  
      console.log('handleStatusUpdate 1',data)
      setLotStatus(
        ["NEXTSLOT", "PASS"].includes(incomingStatus)
          ? "PENDING"
          : incomingStatus
      );
    };
  
    socketDeclarator.on("receive_status", handleStatusUpdate);
    

    return () => {
      socketDeclarator.off("receive_status", handleStatusUpdate);
    };
  }, [LiveDataddd, Datastatus, socketDeclarator,]);
  
  
  const getDisplayStatus = () => {
    const status = Datastatus || lotStatus;
    return status === "NEXTSLOT" || status === "PASS" ? "PENDING" : status;
  };

  return (
    <div style={{ padding: 10 }}>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Typography variant="h5">STATUS:&nbsp;</Typography>
        <Typography variant="h5" style={{ whiteSpace: "break-spaces" }}>
          <BlinkedBox
            style={{
              color: getDisplayStatus() === "SOLD" ? "green" : "red",
            }}
          >
            {getDisplayStatus()}
          </BlinkedBox>
        </Typography>
      </Box>

      
      <Grid item xs={12}>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            fullWidth
            disabled={withdrawn === 1 ? true:lotStatus === "FAIR_WARNING"  ||  Datastatus === "FAIR_WARNING"  ? false :  true}          style={{ margin: 2, color: "white" }}
            variant="contained"
            color="inherit"
            onClick={() => handleClick("SOLD")}
            className={
              getDisplayStatus() === "SOLD"
                ? `${classes.buttonSuccess} ${classes.ButtonCustom}`
                : getDisplayStatus() === "UNSOLD"
                ? `${classes.buttonRed} ${classes.ButtonCustom}`
                : `${classes.buttonNormal} ${classes.ButtonCustom}`
            }
          >
            SOLD
          </Button>

          <Button
            fullWidth
            disabled={withdrawn === 1 ? true : !(lotStatus === "FAIR_WARNING" || Datastatus === "FAIR_WARNING")}
            style={{ margin: 3, color: "white" }}
            variant="contained"
            color="inherit"
            onClick={() => handleClick("UNSOLD")}
            className={
              getDisplayStatus() === "UNSOLD"
                ? `${classes.buttonRed} ${classes.ButtonCustom}`
                : `${classes.buttonNormal} ${classes.ButtonCustom}`
            }
          >
            UNSOLD
          </Button>

          <Button
            fullWidth
            disabled={withdrawn === 1 ? true : !(lotStatus === "FAIR_WARNING" || Datastatus === "FAIR_WARNING")}
            style={{ margin: 3, color: "white" }}
            variant="contained"
            color="inherit"
            onClick={() => handleClick("RESERVE_NOT_MET")}
            className={
              getDisplayStatus() === "RESERVE_NOT_MET"
                ? `${classes.buttonRed} ${classes.ButtonCustom}`
                : `${classes.buttonNormal} ${classes.ButtonCustom}`
            }
          >
            RESERVE NOT MET
          </Button>

          <Button
            fullWidth
            disabled={["SOLD", "UNSOLD", "RESERVE_NOT_MET", "PENDING"].includes(getDisplayStatus())}
            style={{ margin: 3, color: "white" }}
            variant="contained"
            color="inherit"
            onClick={() => handleClick("FAIR_WARNING")}
            className={
              getDisplayStatus() === "FAIR_WARNING"
                ? `${classes.buttonOrange} ${classes.ButtonCustom}`
                : `${classes.buttonNormal} ${classes.ButtonCustom}`
            }
          >
            FAIR_WARNING
          </Button>
        </Box>
      </Grid>

      
      <Grid item xs={12}>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            fullWidth
            disabled={getDisplayStatus() === "PENDING"}
            style={{ margin: 3, color: "white" }}
            variant="contained"
            color="inherit"
            onClick={() => handleClick("PAUSE")}
            className={
              lotStatus === "PAUSE"
                ? `${classes.pauseButton} ${classes.ButtonCustom}`
                : `${classes.buttonNormal} ${classes.ButtonCustom}`
            }
          >
            PAUSE
          </Button>

          <Button
            fullWidth
            style={{ margin: 3, color: "white" }}
            variant="contained"
            onClick={() => handleClick("OPEN")}
            className={
              getDisplayStatus() === "OPEN"
                ? `${classes.buttonBlue} ${classes.ButtonCustom}`
                : `${classes.buttonNormal} ${classes.ButtonCustom}`
            }
          >
            OPEN
          </Button>
        </Box>
      </Grid>

      
      <Grid item xs={12}>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            fullWidth
            style={{ margin: 2, color: "white" }}
            variant="contained"
            color="inherit"
            onClick={handleClickPass}
            className={`${classes.buttonNormal} ${classes.ButtonCustom}`}
          >
            PASS
          </Button>

          <Button
            fullWidth
            disabled={
              !["SOLD", "UNSOLD", "PASS", "RESERVE_NOT_MET"].includes(getDisplayStatus())
            }
            style={{ margin: 2, color: "white" }}
            variant="contained"
            onClick={() => handleClick("NEXTSLOT")}
            className={
              ["SOLD", "UNSOLD", "PASS"].includes(getDisplayStatus())
                ? `${classes.buttonGreen} ${classes.ButtonCustom}`
                : `${classes.buttonNormal} ${classes.ButtonCustom}`
            }
          >
            NEXT SLOT
          </Button>
        </Box>
      </Grid>

      
      <Grid item xs={12}>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            fullWidth
            style={{ margin: 2, color: "white" }}
            variant="contained"
            onClick={handleRefreshAll}
            className={`${classes.buttonNormal} ${classes.ButtonCustom}`}
          >
            Refresh along with other connected users
          </Button>
        </Box>
      </Grid>

      
      
      <Dialog
        open={openPass}
        onClose={handleClosePass}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Confirm Lot Status</DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <Typography style={{ fontSize: 20 }}>
              Are you sure you want to mark this lot as <strong>Passed</strong>?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePass} color="error" variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={() => handleClick("PASS")}
            color="primary"
            variant="contained"
          >
            Yes, Mark as Passed
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ButtonsFunction;
